import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { LicenseMainFormWebComponent } from '../../../../license/licenseMainForm';
import { WEB_COMPONENT_LICENSE_MAIN_FORM } from '../../../../webcomponents.constants';
import { EditLicensingOptionsViewData } from '../types/EditLicensingOptionsViewData';
import { Subscription } from 'rxjs';
import { CompanyLicensingTabHelper } from '../../licensingTab/view/CompanyLicensingTabHelper';
import { CompanyType } from '../../../types/company-type';
import { CompanyData } from '../../../types/company-data';
import { SubscriptionType } from '../../../../license/types/SubscriptionType';

export class EditLicensingOptionsMenuView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $innerContainer: HTMLElement;

    $licenseMainForm: LicenseMainFormWebComponent;

    $saveButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
  };

  private licenseMainFormValidSubscription: Subscription | null = null;

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#licensing-options-wrapper'),
      $innerContainer: this.shadow.querySelector('#licensing-options-inner-container'),

      $licenseMainForm: this.shadow.querySelector(WEB_COMPONENT_LICENSE_MAIN_FORM),

      $saveButton: this.shadow.querySelector('#save-button'),
      $cancelButton: this.shadow.querySelector('#cancel-button'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {}

  setTranslatedStrings() {
    this.dom.$saveButton.innerText = this.dependencies.translateFn('Save#preserve state');
    this.dom.$cancelButton.innerText = this.dependencies.translateFn('Cancel');
  }

  public shouldDisableSaveButton({
    company,
    context,
    companyLicenseInformation,
  }: EditLicensingOptionsViewData): boolean {
    if (!company) {
      return true;
    }

    if (this.dom.$licenseMainForm.getActiveSubscriptionType() !== SubscriptionType.Licensed) {
      return false;
    }

    const shouldAddActionBeVisible = CompanyLicensingTabHelper.shouldAddActionBeVisible(
      company,
      companyLicenseInformation,
      context
    );

    const isLicenseKeyInvalid =
      !this.dom.$licenseMainForm.getLicenseKeyValidity() && !!this.dom.$licenseMainForm.getLicenseKeyFieldValue();

    // Disable button for customer if the license key is empty or invalid
    const shouldDisableButtonForCustomer =
      !this.dom.$licenseMainForm.getLicenseKeyValidity() &&
      this.dom.$licenseMainForm.isLicenseKeyEmpty() &&
      CompanyData.getCompanyType(company) === CompanyType.Customer;

    // check that the prepaid subform has issues, if so, disable the "Save/Next" button
    const shouldDisableButtonForOtherLicenseIssues = this.dom.$licenseMainForm.prepaidSubformHasIssues;

    return shouldAddActionBeVisible || isLicenseKeyInvalid || shouldDisableButtonForCustomer || shouldDisableButtonForOtherLicenseIssues;
  }

  buildSuccessView({ company, context, companyLicenseInformation }: EditLicensingOptionsViewData) {
    this.dom.$licenseMainForm.injectDependencies(this.dependencies);

    this.dom.$licenseMainForm.company = company;
    this.dom.$licenseMainForm.context = context;
    this.dom.$licenseMainForm.companyLicenseInformation = companyLicenseInformation;

    if (this.dom.$licenseMainForm.started) {
      // force re-render
      this.dom.$licenseMainForm.propertiesSet = false;
      this.dom.$licenseMainForm.propertiesSet = true;
    }

    this.dom.$licenseMainForm
      .start()
      .then(() => {
        this.licenseMainFormValidSubscription?.unsubscribe();

        this.licenseMainFormValidSubscription = this.dom.$licenseMainForm.valid$.subscribe({
          next: isLicenseMainFormValid => {
            const isDisabled =
              !isLicenseMainFormValid || this.shouldDisableSaveButton({ company, context, companyLicenseInformation });
            this.dom.$saveButton.disabled = isDisabled;
          },
        });
      })
      .catch(console.error);
  }

  buildErrorView(error: Error) {}
}
